import { ChangeEvent, forwardRef, useMemo } from 'react';

import { LimitTypesEnum } from '@/constants/common';

import * as S from './RangeSlider.styles';

interface RangeSliderProps {
  min: number;
  max: number;
  step: number;
  value?: number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  isActive: boolean;
  type: LimitTypesEnum;
}

export const RangeSlider = forwardRef<HTMLDivElement, RangeSliderProps>(
  ({ min, max, step, value = min, onChange, onBlur, isActive, type }, ref) => {
    const trackWidth = useMemo(() => {
      const percent = ((value - min) / (max - min)) * 100;
      return `${percent / 100}`;
    }, [type, value]);

    return (
      <S.RangeContainer ref={ref}>
        <S.Track $width={trackWidth} $isActive={isActive} />
        <S.Slider
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onPointerUp={onBlur}
          onLostPointerCapture={onBlur}
          onChange={onChange}
        />
      </S.RangeContainer>
    );
  }
);

RangeSlider.displayName = 'RangeSlider';
